import React from "react";
import Navbar from "../../components/Navbar/index.tsx";

const Terms: React.FC = () => {
  return (
    <div className="page">
      <Navbar />
      <div className="container-site px-6 py-6">
        <div className="py-2 pl-2 text-white mb-3">
          <h1 className="text-2xl font-semibold text-glow">
            Terms & Conditions
          </h1>
          <p className="text-white/70">A short placeholder for your terms.</p>
        </div>
        <div className="border border-white/10 bg-white/5 backdrop-blur p-4 text-white/80 leading-relaxed">
          <p>
            These terms are a placeholder. Replace with your actual policy text
            and legal content.
          </p>
        </div>
      </div>
    </div>
  );
};

export default Terms;
